import React, { ReactElement } from 'react';
import { HeaderImagePropsType } from '../../types';

const Standard = ({ url, altText }: HeaderImagePropsType) => {
  return <img data-testid="Standard__Logo" className="sm-thank-you__logo" src={url} alt={altText || ''} />;
};

export default Standard;
